// extracted by mini-css-extract-plugin
export default {"root":"ServiceTerms_root__Zd9Gb","container":"ServiceTerms_container__38NSm","list":"ServiceTerms_list__nSClt"};